export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '特色亮点', href: '#features' },
  { label: '精彩推荐', href: '#media' },
  { label: '常见问题', href: '#faq' },
  { label: '影视索引', href: '#index' },
];

export const heroData = {
  tag: '久久影院 · 悠久影院 · 九九影院 · 55影院',
  h1: '51影院 - 全网影视资源免费在线观看',
  slogan: '电视剧大全 · 电影大全 · 综艺节目一应俱全',
  description: '51影院汇聚久久影院、悠久影院等主流平台的海量影视资源，涵盖国产剧、港台剧、日韩剧、欧美剧等电视剧大全，动作、喜剧、爱情、科幻等全类型电影大全，以及热门综艺节目实时更新。📺 每日同步上新，蓝光高清画质，无需注册即可免费在线观看，手机电脑平板多端畅享，是您追剧观影的首选入口。当前主打暑期热门剧集与经典老片回顾，包含全网热播榜单、高分推荐、独家专题合集。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '高清资源', value: '蓝光1080P' },
    { label: '全端支持', value: '手机/电脑/平板' },
  ],
  ctaPrimary: { label: '立即观影', href: '#index' },
  ctaSecondary: { label: '查看榜单', href: '#ranking' },
};

export const faqItems = [
  {
    q: '51影院需要注册才能观看吗？',
    a: '完全不需要！51影院所有影视资源均可免费在线观看，无需注册、无需登录、无需下载任何播放器。打开网页就能直接看，和久久影院、九九影院一样方便快捷。',
  },
  {
    q: '这里的电视剧和电影是高清画质吗？',
    a: '是的，51影院绝大部分资源均提供720P至1080P高清画质，部分热门剧集和电影大全中的新片还支持蓝光画质。建议使用稳定的网络连接以获得最佳观影体验。',
  },
  {
    q: '51影院每天更新多少内容？',
    a: '51影院每日同步更新200+影视资源，包括当天热播电视剧大全的最新剧集、电影院刚下线的电影大全新片，以及各大平台的热门综艺节目。追剧党再也不怕错过更新。',
  },
  {
    q: '久久影院、悠久影院和51影院是什么关系？',
    a: '51影院是一个影视资源聚合入口，整合了久久影院、悠久影院、九九影院、55影院等多平台的优质内容，方便您一站式浏览电视剧大全、电影大全和综艺节目，无需在多个站点之间来回切换。',
  },
  {
    q: '支持手机和平板观看吗？',
    a: '当然支持！51影院采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您是在家用电脑追剧，还是通勤途中用手机刷综艺节目，都能获得流畅舒适的观看体验。',
  },
  {
    q: '51影院会收费吗？',
    a: '51影院承诺完全免费！所有电视剧大全、电影大全和综艺节目资源均不收取任何费用。我们也不会要求您绑定任何支付方式或开通VIP会员，真正做到不用注册、免费在线观看。',
  },
];

export const mediaItems = [
  {
    title: '最新热播剧集',
    tag: '每日更新',
    description: '同步各大平台最新电视剧集，《庆余年3》《长相思2》等你来追，久久影院同款资源一网打尽。',
    duration: '持续更新中',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20scene%20with%20elegant%20costumes%20in%20warm%20candlelit%20palace%20interior%2C%20cinematic%20lighting%2C%20rich%20red%20and%20gold%20tones%2C%20soft%20depth%20of%20field%2C%20atmospheric%20mood&width=800&height=450&seq=media-hot-drama&orientation=landscape',
  },
  {
    title: '高分电影精选',
    tag: '口碑佳作',
    description: '豆瓣8分以上电影大全精选，《奥本海默》《年会不能停》等高分影片在线观看，画质清晰流畅。',
    duration: '120+ 部精选',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20red%20velvet%20curtains%20and%20soft%20spotlight%2C%20dramatic%20golden%20lighting%2C%20classic%20film%20aesthetic%2C%20elegant%20composition%2C%20no%20people&width=800&height=450&seq=media-movie&orientation=landscape',
  },
  {
    title: '热门综艺合集',
    tag: '爆笑不断',
    description: '《奔跑吧》《极限挑战》《向往的生活》等热门综艺节目任你选，搞笑、竞技、音乐应有尽有。',
    duration: '80+ 档节目',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20neon%20lights%20and%20dynamic%20atmosphere%2C%20warm%20spotlights%2C%20cheerful%20golden%20and%20coral%20tones%2C%20clean%20modern%20design&width=800&height=450&seq=media-variety&orientation=landscape',
  },
  {
    title: '经典老片重温',
    tag: '永不过时',
    description: '《大话西游》《无间道》《霸王别姬》等华语经典，电视剧大全中的老剧神作，高清修复版本随时回顾。',
    duration: '300+ 部经典',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20film%20reel%20and%20vintage%20movie%20posters%20arranged%20artistically%2C%20warm%20sepia%20and%20amber%20tones%2C%20soft%20lighting%2C%20retro%20cinema%20aesthetic%2C%20elegant%20composition&width=800&height=450&seq=media-classic&orientation=landscape',
  },
  {
    title: '动漫番剧专区',
    tag: '热血青春',
    description: '国漫、日漫全收录，《凡人修仙传》《鬼灭之刃》等热门动漫番剧实时更新，二次元爱好者聚集地。',
    duration: '200+ 部番剧',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20warm%20sunset%20sky%20and%20cherry%20blossom%20trees%2C%20soft%20golden%20light%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20vibrant%20coral%20and%20amber%20tones&width=800&height=450&seq=media-anime&orientation=landscape',
  },
];

export const featuresItems = [
  {
    icon: 'ri-movie-2-line',
    title: '海量资源全覆盖',
    description: '整合久久影院、悠久影院、九九影院、55影院等平台资源，电视剧大全涵盖国产、港台、日韩、欧美，电影大全覆盖动作、喜剧、爱情、科幻等全类型，综艺节目每周同步更新。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清流畅不卡顿',
    description: '全站采用高速CDN加速，支持720P至1080P蓝光画质，自适应带宽优化，无论是电脑端还是手机端都能获得稳定流畅的高清在线观看体验。',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: '无需注册免费看',
    description: '51影院坚持开放共享理念，所有影视资源无需注册、无需登录即可免费在线观看。无广告弹窗、无强制跳转、无会员门槛，打开即看。',
  },
];

export const indexItems = [
  { label: '动作大片', icon: 'ri-fire-line', count: '1,200+', color: 'bg-primary-500' },
  { label: '喜剧电影', icon: 'ri-emotion-happy-line', count: '890+', color: 'bg-accent-500' },
  { label: '爱情剧场', icon: 'ri-heart-line', count: '760+', color: 'bg-primary-400' },
  { label: '科幻巨制', icon: 'ri-rocket-line', count: '540+', color: 'bg-accent-400' },
  { label: '恐怖惊悚', icon: 'ri-ghost-line', count: '430+', color: 'bg-secondary-600' },
  { label: '纪录片库', icon: 'ri-earth-line', count: '680+', color: 'bg-primary-500' },
  { label: '国产剧集', icon: 'ri-tv-line', count: '2,100+', color: 'bg-accent-500' },
];

export const contactData = {
  title: '资源投稿与意见反馈',
  description: '如果您有想看的影视资源暂未收录，或对51影院的电视剧大全、电影大全、综艺节目有任何建议，欢迎通过以下方式联系我们。我们会认真对待每一条反馈，持续优化观影体验。',
  email: 'feedback@51cinema.com',
  hint: '我们会在48小时内回复您的来信',
};

export const rankingItems = [
  { rank: 1, title: '庆余年 第三季', tag: '热播', hot: '🔥 980万', type: '国产剧' },
  { rank: 2, title: '奥本海默', tag: '新上', hot: '🔥 860万', type: '电影' },
  { rank: 3, title: '奔跑吧 第十二季', tag: '热门', hot: '🔥 820万', type: '综艺' },
  { rank: 4, title: '长相思 第二季', tag: '热播', hot: '🔥 790万', type: '国产剧' },
  { rank: 5, title: '年会不能停', tag: '高分', hot: '🔥 740万', type: '电影' },
  { rank: 6, title: '极限挑战 第十季', tag: '热门', hot: '🔥 710万', type: '综艺' },
  { rank: 7, title: '凡人修仙传', tag: '热播', hot: '🔥 680万', type: '动漫' },
];

export const appData = {
  title: '随时随地 畅享观影',
  description: '51影院移动端完美适配，无需下载安装任何APP。在手机浏览器中直接访问即可观看所有电视剧大全、电影大全和综艺节目，流量消耗低，画质不打折。',
  features: ['蓝光高清', '数据省流', '夜间模式', '多端同步'],
};

export const topicsItems = [
  { label: '庆余年3', hot: true, count: '1.2万讨论' },
  { label: '长相思2', hot: true, count: '9,800讨论' },
  { label: '暑期档电影', hot: true, count: '8,500讨论' },
  { label: '国产剧推荐', hot: false, count: '7,200讨论' },
  { label: '韩剧大全', hot: false, count: '6,800讨论' },
  { label: '综艺搞笑', hot: true, count: '6,500讨论' },
  { label: '科幻电影', hot: false, count: '5,900讨论' },
  { label: '动漫番剧', hot: false, count: '5,300讨论' },
  { label: '经典港片', hot: false, count: '4,800讨论' },
  { label: '日剧推荐', hot: false, count: '4,200讨论' },
  { label: '纪录片', hot: false, count: '3,600讨论' },
];

export const updatesItems = [
  { time: '2026-07-31 14:30', content: '《庆余年》第三季第28集更新上线，久久影院同步追剧', tag: '剧集更新' },
  { time: '2026-07-31 10:15', content: '电影大全新增《奥本海默》高清1080P版本', tag: '新片入库' },
  { time: '2026-07-30 20:00', content: '综艺节目《奔跑吧》第十二季最新一期同步上线', tag: '综艺更新' },
  { time: '2026-07-30 16:45', content: '动漫专区新增《凡人修仙传》第86集', tag: '动漫更新' },
  { time: '2026-07-30 09:30', content: '《长相思》第二季大结局上线，一次性放出3集', tag: '完结播出' },
  { time: '2026-07-29 18:20', content: '电视剧大全新增港剧《新闻女王2》全集资源', tag: '剧集入库' },
  { time: '2026-07-29 12:00', content: '电影大全评分区上线，多部高分影片收录完成', tag: '专区更新' },
  { time: '2026-07-28 22:10', content: '全站CDN节点升级完成，观影流畅度提升30%', tag: '系统优化' },
];

export const cardsItems = [
  {
    title: '暑期档电影大盘点',
    tag: '专题合集',
    description: '2026暑期档热映影片一网打尽，从国产大片到进口巨制，51影院为您整理最全观影指南，电影大全持续更新中。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20atmosphere%20with%20warm%20golden%20sunset%20and%20movie%20elements%2C%20stylized%20illustration%2C%20coral%20and%20amber%20color%20palette%2C%20artistic%20composition&width=600&height=400&seq=card-summer&orientation=landscape',
  },
  {
    title: '国产剧高分推荐TOP20',
    tag: '榜单',
    description: '从《琅琊榜》到《漫长的季节》，精选20部豆瓣8分以上国产剧，电视剧大全品质之选，每一部都值得反复回味。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20aesthetic%20with%20warm%20lantern%20light%20and%20traditional%20architecture%2C%20soft%20cinematic%20tones%2C%20rich%20red%20and%20gold%20accents%2C%20artistic%20illustration&width=600&height=400&seq=card-drama&orientation=landscape',
  },
  {
    title: '周末电影之夜精选',
    tag: '推荐',
    description: '周末宅家看什么？51影院精选6部高分电影大全推荐，从轻松喜剧到悬疑烧脑，完美搭配你的休闲时光。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20night%20atmosphere%20with%20warm%20ambient%20lighting%2C%20projector%20glow%2C%20comfortable%20setting%2C%20golden%20and%20coral%20tones%2C%20relaxed%20vibe&width=600&height=400&seq=card-weekend&orientation=landscape',
  },
  {
    title: '韩剧甜宠合集',
    tag: '合集',
    description: '《背着善宰跑》《婚礼大捷》等高分韩剧大全甜蜜上线，久久影院同款推荐，每一部都甜到上头停不下来。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20style%20scene%20with%20soft%20cherry%20blossom%20and%20warm%20sunlight%2C%20gentle%20pink%20and%20coral%20tones%2C%20dreamy%20atmosphere%2C%20clean%20composition&width=600&height=400&seq=card-kdrama&orientation=landscape',
  },
  {
    title: '经典港片修复特辑',
    tag: '经典',
    description: '《古惑仔》《英雄本色》《东邪西毒》等港片经典高清修复版上线，重温黄金年代的银幕记忆，电影大全情怀专区。',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20neon%20street%20atmosphere%20at%20night%20with%20warm%20golden%20and%20red%20glowing%20signs%2C%20retro%20cinematic%20aesthetic%2C%20moody%20composition&width=600&height=400&seq=card-hkfilm&orientation=landscape',
  },
  {
    title: '纪录片精选：自然奇迹',
    tag: '精选',
    description: 'BBC、央视顶级纪录片大全，《地球脉动》《美丽中国》等高分作品，高清画质带你领略世界之美，开阔眼界。',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20mountains%20and%20valleys%20with%20warm%20golden%20sunlight%2C%20natural%20earth%20tones%2C%20breathtaking%20vista%2C%20cinematic%20composition&width=600&height=400&seq=card-nature&orientation=landscape',
  },
  {
    title: '家庭观影合家欢',
    tag: '亲子',
    description: '适合全家一起观看的动画电影、合家欢喜剧推荐，电影大全亲子专区，大人小孩都能找到喜欢的影片。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20with%20cozy%20ambient%20light%20and%20comfortable%20seating%2C%20golden%20evening%20atmosphere%2C%20inviting%20home%20interior%2C%20clean%20modern%20design&width=600&height=400&seq=card-family&orientation=landscape',
  },
];

export const commentsItems = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20coral%20and%20red%20gradient%20colors%2C%20minimalist%20style%2C%20clean%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2天前',
    content: '51影院真的太方便了！不用注册直接看，画质还特别清晰。之前一直用久久影院，现在都转到这里了，电视剧大全资源比那边还全，追剧党的福音！',
  },
  {
    name: '电影控老王',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20amber%20and%20gold%20gradient%20colors%2C%20minimalist%20style%2C%20clean%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '3天前',
    content: '电影大全分类很全，想看的片子基本都能找到。高清播放不卡顿，比那些到处都是弹窗广告的站好用太多了。已经推荐给身边所有朋友了。',
  },
  {
    name: '独居少女的日常',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20pink%20and%20coral%20gradient%20colors%2C%20minimalist%20style%2C%20clean%20composition&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '5天前',
    content: '每天晚上必刷51影院的综艺节目，笑到头掉哈哈。手机端适配做得不错，在被窝里刷剧太幸福了。久久影院和55影院的剧这里都有，一站式搞定。',
  },
  {
    name: '影评人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20portrait%20with%20warm%20terracotta%20and%20brown%20gradient%20colors%2C%20minimalist%20style%2C%20clean%20composition&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '1周前',
    content: '作为一个看了20年电影的影视爱好者，51影院的片源质量和更新速度让我惊喜。经典老片的高清修复版本在这里也能找到，电视剧大全的年代跨度很大，良心站点。',
  },
];

export const aboutData = {
  title: '关于51影院',
  description: '51影院是一个致力于提供优质影视资源免费在线观看的聚合平台。我们整合了久久影院、悠久影院、九九影院、55影院等主流影视站点的内容，为用户提供一站式电视剧大全、电影大全和综艺节目浏览体验。\n\n本站所有资源均来自互联网公开分享，坚持开放、免费、无需注册的理念，让每一位用户都能轻松享受高清观影的乐趣。我们每日同步更新200+影视内容，涵盖国产剧、港台剧、日韩剧、欧美剧、动漫番剧、纪录片等全类型资源。\n\n51影院不是内容生产方，而是优质资源的聚合入口。如果您是内容创作者并希望您的作品在这里被更多人发现，欢迎通过我们的联系渠道进行投稿。',
  stats: [
    { label: '影视资源', value: '50,000+' },
    { label: '每日更新', value: '200+' },
    { label: '内容类型', value: '12大类' },
    { label: '在线用户', value: '10万+' },
  ],
};

export const carouselItems = [
  {
    title: '庆余年 第三季',
    subtitle: '全网热播 · 现象级国剧回归',
    description: '张若昀、李沁领衔主演，古装权谋巨制第三季重磅回归。南庆风云再起，范闲的传奇故事继续书写，久久影院同步更新每一集。',
    tag: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20atmosphere%20with%20ancient%20palace%20silhouette%20in%20warm%20golden%20sunset%2C%20rich%20red%20and%20amber%20tones%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '奥本海默',
    subtitle: '诺兰史诗巨制 · 高分必看',
    description: '克里斯托弗·诺兰导演作品，基里安·墨菲主演。讲述"原子弹之父"的传奇一生，电影大全高分推荐，1080P高清画质震撼呈现。',
    tag: '高分佳作',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20cinematic%20scene%20with%20intense%20lighting%20and%20shadow%2C%20warm%20highlight%20accents%2C%20contemplative%20mood%2C%20artistic%20composition&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '奔跑吧 第十二季',
    subtitle: '国民综艺 · 爆笑回归',
    description: '李晨、郑恺、杨颖等常驻MC携新嘉宾阵容欢乐开跑，综艺节目热度冠军，每周准时更新，陪你度过快乐周末时光。',
    tag: '热门综艺',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20outdoor%20game%20show%20atmosphere%20with%20colorful%20decorations%20and%20warm%20sunlight%2C%20joyful%20energy%2C%20dynamic%20composition%2C%20golden%20and%20coral%20tones&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '长相思 第二季',
    subtitle: '古装仙侠 · 口碑续作',
    description: '杨紫、张晚意主演古装仙侠剧第二季，延续第一季高品质制作。久久影院热剧同步，电视剧大全中的人气王，不容错过。',
    tag: '完结推荐',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20drama%20scene%20with%20ethereal%20peach%20blossom%20forest%20and%20mist%2C%20soft%20pink%20and%20gold%20light%2C%20dreamy%20atmosphere%2C%20cinematic%20composition&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
];

export const footerData = {
  description: '51影院 - 久久影院 · 悠久影院 · 九九影院 · 55影院影视资源聚合平台，提供电视剧大全、电影大全、综艺节目免费在线观看，无需注册，高清流畅。',
  quickLinks: [
    { label: '特色亮点', href: '#features' },
    { label: '精彩推荐', href: '#media' },
    { label: '常见问题', href: '#faq' },
    { label: '影视索引', href: '#index' },
    { label: '热度榜单', href: '#ranking' },
    { label: '关于我们', href: '#about' },
  ],
  copyright: '© 2026 51影院 - 本站资源来源于互联网公开分享，仅供交流学习使用。',
};